window.HOST = process.env.MIX_APP_URL;
window.IMAGES_MIMETYPE = process.env.MIX_IMAGES_MIMETYPE;
window.API_PATH = '/api';
window.CALLBACK_NUMBER = process.env.MIX_CALLBACK_NUMBER;

window._ = require('lodash');
window.axios = require('axios');

require('popper.js')
require("bootstrap");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

$('input[type="checkbox"]')
  .on('change', e => $(e.target).val(['on', 'off'].includes(e.target.value) ? (e.target.checked ? 1 : 0) : e.target.value));

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
